/**
 * Where the iOS prompt sends people.
 *
 * Clippn Dashboard is live on the App Store, so the store link is simply the
 * default — the pre-launch "is there anywhere to send them yet" gate is gone.
 * REACT_APP_IOS_APP_URL still overrides it, which is how a deployment can be
 * pointed at a TestFlight build without a code change.
 *
 * The link deliberately carries no storefront (no /pl/, no /us/): Apple
 * redirects id-only links to whichever store the visitor belongs to, so one
 * URL works for contributors wherever they are.
 */

export const APP_STORE_URL = "https://apps.apple.com/app/id6798767088";

export const resolveIosAppLink = ({
  configuredUrl = process.env.REACT_APP_IOS_APP_URL,
} = {}) => {
  const url = (configuredUrl || "").trim();

  return { url: url || APP_STORE_URL };
};
